import type { Comment } from '@/shared/types';
import { getUserById } from '@/shared/data';
import { Avatar } from '@/shared/ui/Avatar';
import { formatRelativeTime } from '@/shared/utils/format';

export function CommentList({ comments }: { comments: Comment[] }) {
  if (comments.length === 0) {
    return (
      <div className="text-white/40 text-sm italic px-4 py-6">
        No comments yet — be the first.
      </div>
    );
  }
  return (
    <ul className="px-4 space-y-4">
      {comments.map((c) => {
        const u = getUserById(c.authorId);
        const username = u?.username ?? 'guest';
        const avatar =
          u?.avatar ??
          'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=200&q=80';
        return (
          <li key={c.id} className="flex gap-3">
            <Avatar src={avatar} alt={username} size={32} />
            <div className="flex-1">
              <div className="text-sm">
                <span className="text-white/90 font-medium">@{username}</span>{' '}
                <span className="text-white/80">{c.text}</span>
              </div>
              <div className="text-[10px] text-white/40 mt-1 uppercase tracking-wider">
                {formatRelativeTime(c.createdAt)}
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
